import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadContacts = async () => {
  try {
    const response = await Axios.get('contacts');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadContact = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/contacts');
        const requestData = await response.data;
        return {...requestData, contact: {}};
        
      default:
        const respnse = await Axios.get('contacts/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useContactAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('contacts', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('contact_created', responseData.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('contacts/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('contact_created', responseData.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useContactAPI;


